/**
 * Dados de apoio do fluxo de Proposta PME (etapas do wizard).
 *
 * Estipulante, Plano/Coberturas e Resumo são hidratados com dados reais da
 * cotação (ver `utils/hydrate-proposal.util.ts`). Aqui ficam apenas os selects
 * de nível de produto que o back ainda não fornece como catálogo (atividade,
 * UF e opções de pagamento).
 */
import type { SelectFieldOption } from '@/shared/components/form-fields/factories/create-form-fields';

// ─── Selects do passo Dados do Seguro (nível de produto) ────────────────────

export const PME_ACTIVITY_OPTIONS: SelectFieldOption[] = [
  { label: 'Comércio varejista', value: 'comercio-varejista' },
  { label: 'Indústria de transformação', value: 'industria-transformacao' },
  { label: 'Serviços administrativos', value: 'servicos-administrativos' },
  { label: 'Construção civil', value: 'construcao-civil' },
];

export const PME_UF_OPTIONS: SelectFieldOption[] = [
  'AC',
  'AL',
  'AP',
  'AM',
  'BA',
  'CE',
  'DF',
  'ES',
  'GO',
  'MA',
  'MT',
  'MS',
  'MG',
  'PA',
  'PB',
  'PR',
  'PE',
  'PI',
  'RJ',
  'RN',
  'RS',
  'RO',
  'RR',
  'SC',
  'SP',
  'SE',
  'TO',
].map(uf => ({ label: uf, value: uf }));

// ─── Selects do passo Pagamento (nível de produto) ──────────────────────────

export const PME_BILLING_FREQUENCY_OPTIONS: SelectFieldOption[] = [
  { label: 'Mensal', value: 'mensal' },
  { label: 'Trimestral', value: 'trimestral' },
  { label: 'Semestral', value: 'semestral' },
  { label: 'Anual', value: 'anual' },
];

export const PME_PAYMENT_METHOD_OPTIONS: SelectFieldOption[] = [
  { label: 'Boleto', value: 'boleto' },
  { label: 'Débito em conta', value: 'debito' },
  { label: 'Cartão de crédito', value: 'cartao' },
];

export const PME_BILLING_CUT_OPTIONS: SelectFieldOption[] = [
  { label: 'Postecipado', value: 'postecipado' },
  { label: 'Durante o mês', value: 'durante-o-mes' },
];

// ─── Tipos compartilhados de exibição (tabelas do resumo) ───────────────────

export type PmeLifeRow = {
  id: string;
  status: 'active' | 'pending' | 'inactive';
  insurableGroup: string;
  capital: string;
  sex: string;
  birthDate: string;
  name: string;
  memberId?: string;
  targetId?: string;
  cpf?: string;
  gender?: 'M' | 'F' | '';
  cids?: string[];
  awayFromWork?: boolean;
  /**
   * Múltiplo Salarial: o `capital` desta linha é o salário da vida e a coluna
   * multiplica pela quantidade de salários. Capital vindo da tarifação já
   * chega multiplicado e fica com a flag ausente.
   */
  multiplySalary?: boolean;
  /** Cruza o capital da vida com a tarifação na análise. */
  policyElementId?: number | string;
};

export type PmeDemonstrativeRow = {
  description: string;
  value: string;
  iof: string;
  total: string;
};
